var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.60005 0.799805C5.26868 0.799805 5.00005 1.06843 5.00005 1.3998C5.00005 1.73118 5.26868 1.9998 5.60005 1.9998H7.15152L3.37578 5.77554C3.14147 6.00986 3.14147 6.38975 3.37578 6.62407C3.6101 6.85838 3.99 6.85838 4.22431 6.62407L8.00005 2.84833V4.3998C8.00005 4.73118 8.26868 4.9998 8.60005 4.9998C8.93142 4.9998 9.20005 4.73118 9.20005 4.3998V1.3998C9.20005 1.06843 8.93142 0.799805 8.60005 0.799805H5.60005Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00005 1.9998C1.33731 1.9998 0.800049 2.53706 0.800049 3.1998V7.9998C0.800049 8.66255 1.33731 9.19981 2.00005 9.19981H6.80005C7.46279 9.19981 8.00005 8.66255 8.00005 7.9998V6.1998C8.00005 5.86843 7.73142 5.5998 7.40005 5.5998C7.06868 5.5998 6.80005 5.86843 6.80005 6.1998V7.9998H2.00005V3.1998L3.80005 3.1998C4.13142 3.1998 4.40005 2.93118 4.40005 2.5998C4.40005 2.26843 4.13142 1.9998 3.80005 1.9998H2.00005Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLink);
export default __webpack_public_path__ + "static/media/open-link.50d175357e7c4db56800f73fbd924b3e.svg";
export { ForwardRef as ReactComponent };